import ErrorLogger from "@kaspernj/api-maker/build/error-logger"

if (window.RAILS_ENV == "test") {
  window.errorLogger = new ErrorLogger()
  window.errorLogger.enable()
}
